























































































































































import { v4 as uuidv4 } from 'uuid';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import SearchAndOrder from '@core/interfaces/bpc-search-and-order';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';

@Component({
  name: 'bulk-edit-modal',
  components: {
    'bpc-std-form': StdForm,
  },
})
export default class BulkEditModal extends Vue {
  $refs: {
    stdBulkEditForm: InstanceType<typeof StdForm> & {
      formModel: any;
      prepareToSave(entity: any);
    };
  };
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String, default: 'bulk-edit' }) readonly modalId: string;
  @Prop({ type: String, default: null }) readonly entityName: string;
  @Prop({ type: Object, default: null }) readonly filters: object;
  @Prop({ type: Object, default: null }) readonly searchAndOrder: SearchAndOrder;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly selectedEntities: string[];
  @Prop({ type: Number, default: 0 }) readonly totalEntities: number;
  @Prop({ type: Boolean, default: false }) readonly checkedAll: boolean;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly dataToShow: [string[]];
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly extraData: object;

  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly extraFields: object;

  @Prop({ type: Boolean, default: false }) readonly needConfirmation: boolean;

  // Data
  public bulkEditEventsError: object[] = [];
  public bulkEditEventsSuccess: object[] = [];
  public bulkEditRequestSent: boolean = false;
  public isBulkEditing: boolean = false;
  public reportPerPage: number = 20;
  public reportCurrentPage: number = 1;
  public processAll: boolean = false;

  // Lifecycle
  mounted() {
    if (this.showModal) {
      this.openModal();
    }
  }

  // Computed
  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }
  get title() {
    return this.$t('global.modals.bulk-edit.title', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }
  get body() {
    return this.$t('global.modals.bulk-edit.body', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }
  get reportRows() {
    return this.bulkEditEventsError.length;
  }
  get reportCurrentList() {
    const start = this.reportCurrentPage * this.reportPerPage - this.reportPerPage;
    const end = start + this.reportPerPage;
    return this.bulkEditEventsError.slice(start, end);
  }
  get bulkEditPath(): string {
    return `${this.$bpcApiRouteHelper.getEntityPath(this.entityName)}/bulk-edit`;
  }

  // Methods
  openModal(): void {
    this.resetModal();
    this.$bvModal.show(this.modalId);
  }
  closeModal(): void {
    this.resetModal();
    this.$bvModal.hide(this.modalId);
  }
  resetModal(): void {
    this.bulkEditEventsError = [];
    this.bulkEditEventsSuccess = [];
    this.bulkEditRequestSent = false;
    this.isBulkEditing = false;
    // NOTE important to reset this value otherwise the next time the modal
    // is opened it will be potentially true
    this.processAll = false;
  }
  onConfirmBulkEdit(): void {
    this.$emit('on-click-confirm');
    if (!this.needConfirmation) {
      this.saveBulkEdit();
    }
  }
  saveBulkEdit(): void {
    const sessionCode = this.getSessionCode();
    this.listenToWebsocketBulkEditChannel(sessionCode);
    this.bulkEditRequestSent = true;
    const dataToPrepare = this.$refs.stdBulkEditForm['formModel'];
    const data = this.$refs.stdBulkEditForm.prepareToSave(dataToPrepare);
    if (this.extraFields['defaultValueSwitchModel']) {
      data.defaultValueSwitchModel = {
        ...data.defaultValueSwitchModel,
        ...this.extraFields['defaultValueSwitchModel'],
      };
    }
    this.$bpcApi
      .post(this.bulkEditPath, {
        entities: this.selectedEntities,
        filters: this.filters,
        search_and_order: this.searchAndOrder,
        process_all: this.processAll,
        session_code: sessionCode,
        data: { ...data, ...this.extraData },
      })
      .subscribe(
        res => {
          this.$emit('request-sent');
        },
        error => {
          this.$emit('error-sending-request');
          this.$bpcEcho.leaveBulkEditChannel(sessionCode);
          this.resetModal();
        },
      );
  }
  getSessionCode(): string {
    return `${uuidv4()}`;
  }
  listenToWebsocketBulkEditChannel(sessionCode): void {
    this.isBulkEditing = true;
    this.$bpcEcho
      .listenBulkEditChannel(sessionCode)
      .listen('.BPC\\Core\\Events\\EntitiesEdited', data => {
        this.$bpcMessage.showInfoMessage({
          text: 'global.actions.bulk_edit.entities_edited',
        });
        this.isBulkEditing = false;
        this.$emit('edited');
        this.$bpcEcho.leaveBulkEditChannel(sessionCode);
      })
      .listen('.BPC\\Core\\Events\\EntityEdited', data => {
        this.bulkEditEventsSuccess.push(data);
      })
      .listen('.BPC\\Core\\Events\\ErrorEditingEntity', data => {
        this.bulkEditEventsError.push(data);
      });
  }
  onCloseModal(): void {
    this.$emit('on-close-modal');
  }

  // Watchers
  @Watch('showModal')
  onChangeShowModal(val) {
    if (val) {
      this.openModal();
    } else {
      this.closeModal();
    }
  }
}
